import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthGuard } from "@atenea-cms";
import { ProductListComponent } from "./product-list/product-list.component";
import { ProductDetailComponent } from "./product-detail/product-detail.component";

const routes: Routes = [
  {
    path: "products",
    component: ProductListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "products/new",
    component: ProductDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "products/:id",
    component: ProductDetailComponent,
    canActivate: [AuthGuard],
  },
];

export const ProductsRoutes: ModuleWithProviders = RouterModule.forChild(
  routes
);



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/products.routes.ts